import { ProgressStepper as AntdProgressStepper } from "@empglabs/backoffice-ui-kit"

const ProgressStepper = props => {
  return <AntdProgressStepper {...props} />
}

export default ProgressStepper
